export async function http_get(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    resolve(xhr.responseText)
                } else {
                    reject('[http_get]: Received non-OK status (' + xhr.status + ') for GET ' + url);
                }
            }
        };

        xhr.open('GET', url);
        xhr.send();
    });
}